import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetDomainsQuery } from '../redux/apis/domainsManagement/domains/dMDomainsApiSlice'

const DomainDropdown = ({
  onChange,
  onBlur,
  value,
  className = '',
  domain_category = null,
  createWhitelist,
  isAll =false
}) => {
  const {
    data,
    isLoading: isLoading1,
    error: error1
  } = useGetDomainsQuery(
    {
      page: '*',
      fields: ['id', 'domain_name'].join(','),
      domain_category
    },
    {
      skip: createWhitelist
    }
  )
  const {
    data: data2,
    isLoading: isLoading2,
    error: error2
  } = useGetDomainsQuery(
    {
      page: '*',
      fields: ['id', 'domain_name'].join(','),
      domain_category: '2'
    },
    {
      skip: !createWhitelist
    }
  )
  const {
    data: data3,
    isLoading: isLoading3,
    error: error3
  } = useGetDomainsQuery(
    {
      page: '*',
      fields: ['id', 'domain_name'].join(','),
      domain_category: '4'
    },
    {
      skip: !createWhitelist
    }
  )
  const combinedData = createWhitelist
    ? [...(data2?.data?.results || []), ...(data3?.data?.results || [])]
    : data?.data?.results || []
  const isLoading = isLoading1 || isLoading2 || isLoading3
  const error = error1 || error2 || error3



  let options

  if (combinedData) {
      options = combinedData?.map(x => {
          return { label: x.domain_name, value: x.id }
      })
      if (isAll) {
          options = [{ label: "All Domains", value: "*" }, ...options]
      }

  }
  useEffect(() => {
    if (!error && !isLoading) {
      return
    }
    toast.error(error)
  }, [error, isLoading])

  return (
    <div className=' mb-3'>
      <Loader isLoading={isLoading} />
      <label className="form-label">Domain</label>
      <br />
      <Select
        name='service'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={options}
      />
    </div>
  )
}

export default DomainDropdown
